module.exports = __webpack_public_path__ + "static/media/g90-logo-colored.744bfa72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/g90-logo-colored.svg
// module id = 2823
// module chunks = 0